const getSharedUrl = (id) => `/espositori/${id}/email_appuntamento`;

export const getExhibitorSettings = async ({ network, id }) =>
  await network.azureMatchmakingLambda({
    params: getSharedUrl(id),
    customMethod: 'get',
    data: {},
    federationId: id,
  });

export const updateExhibitorSettings = async ({
  network,
  id,
  data = {
    email: '',
    prenotazione_appuntamenti: '',
  },
}) => {
  const { email, prenotazione_appuntamenti } = data;
  const input = {
    data: {
      email,
      prenotazione_appuntamenti,
    },
  };
  return await network.azureMatchmakingLambda({
    params: getSharedUrl(id),
    customMethod: 'put',
    data: input,
    federationId: id,
  });
};

export const hasValidSettings = (obj) =>
  'email' in obj && 'prenotazione_appuntamenti' in obj;
